import {fp} from '.';

export const flattenObject = fp.curryN(2, (path: string, obj: any) => {
  return fp.merge(obj, fp.getOr({}, path, obj));
});
